import { useSelector } from "react-redux";

// Components

import TextInput from "../../../UI/FormInput/TextInput";
import DropDownInput from "../../../UI/FormInput/DropDownInput";
import CalendarInput from "../../../UI/FormInput/CalendarInput";
import MaskInput from "../../../UI/FormInput/MaskInput";
import FormInputGroup from "../../../UI/FormInputGroup/FormInputGroup";

// Utilities

import { formatDropDownOptions, getCurrentDateMinusYears, formatDropDownOptionsNationality } from "../../../../utilities/helper-functions";

// Constants

import { IDENTIFICATION_MASK_FORMAT, FULL_PHONE_MASK_FORMAT } from '../../../../config/constants';

export default function AssociateFields({ formik, index }) {
    const dropDownOptions = useSelector((state) => state.options.dropDownOptions);

    return (
        <div key={index}>
            <h3 className="multiple-input-heading">
                Parentesco o Asociado{" "}
                {formik.values?.pep.pregunta2?.length > 1 && index + 1}{" "}
            </h3>

            <FormInputGroup>

                <DropDownInput
                    formik={formik}
                    fieldName={`pep.pregunta2.${index}.tipoDeRelacion`}
                    label={'Tipo de relación'}
                    options={formatDropDownOptions(dropDownOptions?.data?.relationshipTypes)}
                    isRequired={true}
                />

                <TextInput
                    formik={formik}
                    fieldName={`pep.pregunta2.${index}.nombrePersona`}
                    label={'Nombre del la persona'}
                    maxLength={42}
                    isRequired={true}
                    isAlphabetic
                />

                <MaskInput
                    formik={formik}
                    fieldName={`pep.pregunta2.${index}.documentoIdentidad`}
                    label={'Documento de Identidad'}
                    mask={IDENTIFICATION_MASK_FORMAT}
                    isRequired={true}
                />

                <CalendarInput
                    formik={formik}
                    fieldName={`pep.pregunta2.${index}.fechaNacimiento`}
                    label={'Fecha de Nacimiento'}
                    minDate={getCurrentDateMinusYears(90)}
                    maxDate={getCurrentDateMinusYears(18)}
                    isRequired={true}
                />

                <DropDownInput
                    formik={formik}
                    fieldName={`pep.pregunta2.${index}.genero`}
                    label={'Género'}
                    options={formatDropDownOptions(dropDownOptions?.data?.genders)}
                    isRequired={true}
                />

                <DropDownInput
                    formik={formik}
                    fieldName={`pep.pregunta2.${index}.lugarNacimiento`}
                    label={'Lugar de nacimiento'}
                    options={formatDropDownOptions(dropDownOptions?.data?.countries)}
                    isRequired={true}
                />

                <DropDownInput
                    formik={formik}
                    fieldName={`pep.pregunta2.${index}.nacionalidad`}
                    label={'Nacionalidad'}
                    options={formatDropDownOptionsNationality(dropDownOptions?.data?.nationalities)}
                    isRequired={true}
                />

                <DropDownInput
                    formik={formik}
                    fieldName={`pep.pregunta2.${index}.otraNacionalidad`}
                    label={'Otra Nacionalidad'}
                    options={formatDropDownOptionsNationality(dropDownOptions?.data?.nationalities)}
                    showClear
                />

                <DropDownInput
                    formik={formik}
                    fieldName={`pep.pregunta2.${index}.profesion`}
                    label={'Profesión'}
                    options={formatDropDownOptions(dropDownOptions?.data?.professions)}
                    isRequired={true}
                />

                <TextInput
                    formik={formik}
                    fieldName={`pep.pregunta2.${index}.direccionFiscal`}
                    label={'Dir. Fiscal'}
                    maxLength={250}
                    isRequired={true}
                />

                <MaskInput
                    formik={formik}
                    fieldName={`pep.pregunta2.${index}.telefono`}
                    label={'Teléfono'}
                    mask={FULL_PHONE_MASK_FORMAT}
                    isRequired={true}
                />

                <TextInput
                    formik={formik}
                    fieldName={`pep.pregunta2.${index}.nombreEnteAdscrito`}
                    label={'Nombre del ente de adscripción'}
                    maxLength={80}
                    isRequired={true}
                />

                <DropDownInput
                    formik={formik}
                    fieldName={`pep.pregunta2.${index}.nombreCargo`}
                    label={'Nombre del cargo'}
                    options={formatDropDownOptions(dropDownOptions?.data?.positions)}
                    isRequired={true}
                />

                <DropDownInput
                    formik={formik}
                    fieldName={`pep.pregunta2.${index}.pais`}
                    label={'Pais'}
                    options={formatDropDownOptions(dropDownOptions?.data?.countries)}
                    isRequired={true}
                />

            </FormInputGroup>

        </div>
    )
}
